import { useTranslation } from 'react-i18next';

import Lock from '@/assets/lock-yellow.svg';
import { Button } from '@/components/Elements';
import { defaultModalStyles } from '@/components/Elements/Modal/customStyles';

import { PaymentsModal } from '../PaymentsModal';

export type SecurityModalProps = {
  isOpen?: boolean;
  onRequestClose: () => void;
  onClick: () => void;
};

export const SecurityModal = ({ isOpen = false, onRequestClose, onClick }: SecurityModalProps) => {
  const { t } = useTranslation();
  const onDefaultRequestClose = () => {
    onRequestClose();
  };

  return (
    <PaymentsModal
      isOpen={isOpen}
      closeButton={true}
      style={defaultModalStyles}
      onRequestClose={onDefaultRequestClose}
    >
      <h2 className="md__payments__modal__title--h2">{t('SecurityModal.savedSuccess')}</h2>
      <img width="100" src={Lock} alt={t('SecurityModal.savedSuccess')} className="mb-8 m-auto" />
      <h3 className="md__payments__modal--h3">{t('SecurityModal.goToTextLabel')}</h3>

      <Button
        className="m-auto mt-10 py-2 lg:py-4 text-xs lg:text-sm w-[300px] rounded-full"
        variant="primary"
        size="free"
        type="button"
        title={t('HelpContainer.actionButton')}
        onClick={onClick}
      >
        {t('HelpContainer.actionButton')}
      </Button>
    </PaymentsModal>
  );
};
